import { FaLinkedinIn, FaLocationDot } from "react-icons/fa6";
import { FiFacebook } from "react-icons/fi";
import { ImLinkedin } from "react-icons/im";
import { MdEmail } from "react-icons/md";
import { PiPhoneCallFill } from "react-icons/pi";
import ContactForm from '../components/ContactForm'

export default function ContactUs() {
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col items-center ">
      {/* Hero Section */}
      <div
        className="relative w-full h-[350px] bg-cover bg-center flex items-center justify-center text-white"
        style={{ backgroundImage: "url('/contactImg.jpg')" }}
      >
        <div className="bg-black bg-opacity-50 w-full h-full flex flex-col justify-center items-center">
          <h1 className="text-5xl font-bold hover:text-sky-400">Contact Us</h1>
        </div>
      </div>


      {/* Contact Information Section */}
      <div className="container mx-auto  lg:px-16 md:px-8 sm:px-4 py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Office Address */}
        <div className="bg-white p-6 rounded-2xl shadow-lg flex flex-col items-center text-center">
          <div className="bg-sky-400 font-bold text-white p-4 rounded-full">
            <FaLocationDot size={30} />
          </div>
          <h3 className="text-xl font-semibold mt-4">Our Office Address</h3>
          <p> 16th Main Rd, Mahadeshwara Nagar, BTM 2nd Stage, BTM Layout, Bengaluru, Karnataka 560076
          </p>
        </div>

        {/* Call Us */}
        <div className="bg-white p-6 rounded-2xl shadow-lg flex flex-col items-center text-center">
          <div className="bg-sky-400 text-white p-4 rounded-full">
            <PiPhoneCallFill size={30} />
          </div>
          <h3 className="text-xl font-semibold mt-4">Call Us Anytime</h3>
          <a href="tel:+917019291371" className="text-gray-600 mt-2 hover:text-blue-400">
            +91 70192 91371
          </a>
        </div>

        {/* Email Us */}
        <div className="bg-white p-6 rounded-2xl shadow-lg flex flex-col items-center text-center">
          <div className="bg-sky-400 text-white p-4 rounded-full">
            <MdEmail size={30} />
          </div>
          <h3 className="text-xl font-semibold mt-4">Send An Email</h3>
          <a href="mailto:info@infyst.in" className="text-gray-600 mt-2 hover:text-blue-400">
            info@infyst.in
          </a>
        </div>

        {/* Linkedin */}
        <div className="bg-white p-6 rounded-2xl shadow-lg flex flex-col items-center text-center">
          <div className="bg-sky-400 text-white p-4 rounded-full">
            <ImLinkedin size={30} />
          </div>
          <h3 className="text-xl font-semibold mt-4">Connect Us on LinkedIn</h3>
          <a href="https://www.linkedin.com/company/infyst-technologies/" className="text-gray-600 mt-2 hover:text-blue-400">
            LinkedIn
          </a>
        </div>

        {/* Facebook */}
        <div className="bg-white p-6 rounded-2xl shadow-lg flex flex-col items-center text-center">
          <div className="bg-sky-400 text-white p-4 rounded-full">
            <FiFacebook size={30} />
          </div>
          <h3 className="text-xl font-semibold mt-4">Let's get connected on facebook</h3>
          <a href="https://www.linkedin.com/company/infyst-technologies/" className="text-gray-600 mt-2 hover:text-blue-400">
            Facebook
          </a>
        </div>
      </div>

      <div className="flex  items-center px-16 mb-20 w-full gap-20">

        {/* Form ................. */}
        <ContactForm />


      {/* Office address by Map............. */}
        <div className="mx-auto" style={{ width: "100%",  textAlign: "center" }}>
         
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345093747!2d77.611385!3d12.9064631!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae159999a15eed%3A0x41ccfd49a025711f!2sNo%3A1%2C%2016th%20Main%20Rd%2C%20Mahadeshwara%20Nagar%2C%20BTM%202nd%20Stage%2C%20BTM%20Layout%2C%20Bengaluru%2C%20Karnataka%20560076!5e0!3m2!1sen!2sin!4v1712234567890"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
}